import { Link } from "react-router-dom";

const FRIEND_LINKS = [
  { label: "影视资讯", href: "https://www.example.com/news" },
  { label: "影评社区", href: "https://www.example.com/review" },
  { label: "片单收藏", href: "https://www.example.com/lists" },
  { label: "观影指南", href: "https://www.example.com/guide" },
  { label: "版权声明", href: "https://www.example.com/copyright" },
];

export default function Footer() {
  return (
    <footer className="mt-16 w-full border-t border-background-800 bg-gradient-to-b from-background-900 via-secondary-950 to-primary-950/40">
      <div className="mx-auto w-full px-4 py-12 md:px-6 lg:px-10 lg:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-950">
                <i className="ri-movie-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-50">
                麻豆<span className="text-primary-500">免费视频</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-400">
              专注为影视爱好者提供电影、电视剧、综艺节目的在线观看体验，分类清晰、检索便捷，随时随地畅享高清内容。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100">
              <a href="#top" className="transition-colors hover:text-primary-400">内容分类</a>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/category/movie" className="text-foreground-400 transition-colors hover:text-primary-400">高清电影</Link></li>
              <li><Link to="/category/tv" className="text-foreground-400 transition-colors hover:text-primary-400">热播电视剧</Link></li>
              <li><Link to="/category/variety" className="text-foreground-400 transition-colors hover:text-primary-400">热门综艺</Link></li>
              <li><Link to="/favorites" className="text-foreground-400 transition-colors hover:text-primary-400">我的收藏</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100">
              <a href="#top" className="transition-colors hover:text-primary-400">友情链接</a>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {FRIEND_LINKS.slice(0, 4).map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    rel="nofollow"
                    target="_blank"
                    className="text-foreground-400 transition-colors hover:text-primary-400"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100">
              <a href="#top" className="transition-colors hover:text-primary-400">温馨提示</a>
            </h4>
            <p className="mt-4 text-sm leading-relaxed text-foreground-400">
              本站影视资料与封面均为演示内容，<strong className="font-medium text-accent-400">播放功能为演示演示，真实播放功能待接入</strong>。收藏仅保存在本地浏览器，不涉及任何后端存储。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-800 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 麻豆免费视频 · 高清影视视频在线观看平台</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>本站为演示站点</span>
            <span className="hidden sm:inline">·</span>
            <span>内容仅供学习交流使用</span>
          </p>
        </div>
      </div>
    </footer>
  );
}